import { render } from "./AnnotationAlertIcon.vue?vue&type=template&id=515f6acf"
import script from "./AnnotationAlertIcon.vue?vue&type=script&lang=js"
export * from "./AnnotationAlertIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__